export const SPEED_ARG = 0.0058;

export const DEFAULT_TRACK_SIZE = 12;

export const DEFAULT_RENDER_INTERVAL = 150; // 队列巡检时间间隔
